import {Component, forwardRef, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {PositionSearchModel} from "../position-search.model";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {PositionSearchPageComponent} from "../position-search-page/position-search-page.component";
import {PositionEditPageComponent} from "../position-edit-page/position-edit-page.component";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";

const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => PositionSingleSelectEditControlComponent),
    multi: true
};

@Component({
    selector: "wbo-position-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        CUSTOM_VALUE_ACCESSOR,
        provideSearchModel(PositionSearchModel)
    ]
})
export class PositionSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<PositionSearchModel> {
    constructor(model: PositionSearchModel, injector: Injector) {
        super(model, injector, "positionId", "name");

        this.extendedSearchComponent = PositionSearchPageComponent;
        this.extendedEditComponent = PositionEditPageComponent;
    }
}
